module.exports = __webpack_public_path__ + "img/IMG_1899_L_Foamcore_MockedUp.dc5b1623.jpg";